<style scoped>
  .contentbox {
    width: 100vw;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .logobox{
    width: 50%;
    position: absolute;
    top: 180px;
  }
  .logobox-img{
    width: 100%;
  }
  .logobox-btn{
    position: absolute;
    top: 420px;
  }
</style>
<template>
  <div class="contentbox">
    <div class="logobox">
      <img class="logobox-img" src="../assets/images/blmlogo.jpg"/>
    </div>
    <div class="logobox-btn">
      <el-button type="success" @click="goMiniApp">进入菠萝蜜短剧</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageOptions:null,
      link:'weixin://dl/business/?t=jBH6xzIJQ6v'
    }
  },
  computed: {
  },
  mounted: function () {
    console.log("落地页参数",this.$route.query)
    this.pageOptions = this.$route.query
  },
  methods: {
    goMiniApp(){
      console.log("跳转小程序",this.pageOptions)
      if (this.link) {
        window.open(this.link, '_blank');  // 在新标签页打开链接
      } else {
        alert('链接无效，请稍后重试！');
      }
    }
  }
}
</script>